<template>
  <path pid="0" d="M2 17.75a3 3 0 001.65 2.7l8 4a3 3 0 002.69 0l8-4A3 3 0 0024 17.76V8.23a3 3 0 00-1.66-2.68l-8-4A3 3 0 0013 1.23a3 3 0 00-1.33.32l-4 2-.16.07-3.85 1.93A3 3 0 002 8.23zm20 0a1 1 0 01-.55.9L14 22.38v-9.77l8-4zM12.56 3.34a1 1 0 01.88 0L20.76 7 18 8.37 10.24 4.5zM8 5.61l7.75 3.88L13 10.88 5.24 7zm-4 3l8 4v9.78l-7.45-3.73a1 1 0 01-.55-.9z"/>
</template>
